import React, { useEffect, useState } from 'react';

export type CountDownTimerProps = {
  initialSeconds: number;
  onEnd(): void;
};

const CountDownTimer = ({ initialSeconds, onEnd }: CountDownTimerProps): JSX.Element => {
  const [currentSeconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const timer = setTimeout(() => setSeconds((seconds) => seconds - 1), 1000);
    if (currentSeconds === 0) {
      onEnd();
    }
    return (): void => clearTimeout(timer);
  });

  function formatTimer(seconds: number): string {
    const minutesFormat = Math.floor((seconds % 3600) / 60);
    const secondsFormat = Math.floor(seconds % 60)
      .toString()
      .padStart(2, '0');
    return `${minutesFormat}:${secondsFormat}`;
  }

  return <span data-testid="countdown-timer">{formatTimer(currentSeconds)}</span>;
};

export default CountDownTimer;
